import { useSelector } from 'bundles/research/index/store/hooks';

import { researchInformationMappings } from 'helpers/research/research_info_mappings';

export function useCurrentColumnProps() {
  const currentColumns = useSelector(state => state.session.currentColumns);
  const edgeCrm = useSelector(state => state.features.edgeCrm);

  return {
    currentColumns: getCurrentColumns(currentColumns, edgeCrm),
    informationMappings: getInformationMappings(edgeCrm),
  };
}

function getCurrentColumns(currentColumns: string[], edgeCrm?: boolean) {
  return currentColumns.filter(column => column !== 'databaseName' || !edgeCrm);
}

function getInformationMappings(edgeCrm?: boolean) {
  const informationMappings = { ...researchInformationMappings };

  if (edgeCrm) {
    delete informationMappings.propertyInformation.mappings.databaseName;
    informationMappings.propertyInformation.mappings.activeDealCount = 'Active Deals';
    informationMappings.propertyInformation.mappings.activeEdgeProjectCount = 'Active Listings';
  }

  return informationMappings;
}
